import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackInteractionDirective } from '@analytics/events';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';

import { Faq } from '../models/faq.model';
import { FeedbackComponent } from '../feedback/feedback.component';
import { FeedBackSettings } from '../models/feedback.model';

@Component({
  selector: 'wl-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.essent.scss', './faq.component.ed.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CommonUiUtilityComponentsModule,
    TrackInteractionDirective,
    FeedbackComponent,
  ],
})
export class FaqComponent {
  readonly faq = input.required<Faq>();
  readonly feedbackSettings = input<FeedBackSettings>();
}
